import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {RootState} from "@/store/Store";

export interface DocumentTypesInterface {
    formVisible: boolean,
    formVariant: "new" | "edit",
    editId: number,
    editTitle: string,
    editAlias: string,
    editDescription: string,
    editIsActive: boolean | null,
    deleteStatusModalVisible: boolean,
    deleteId?: string,
}

function getInitialState(): DocumentTypesInterface {
    return {
        formVisible: false,
        formVariant: "new",
        deleteStatusModalVisible: false,
        editId: -1,
        editTitle: "",
        editAlias: "",
        editDescription: "",
        editIsActive: null,
    }
}

export const DocumentTypesSlice = createSlice({
    name: "DocumentTypesSlice",
    initialState: getInitialState(),
    reducers: {
        changeFormVisibility: (state: DocumentTypesInterface, action: PayloadAction<boolean>) => {
            state.formVisible = action.payload;
        },
        reset: (state: DocumentTypesInterface, action: PayloadAction<void>) => {
            const initialState = getInitialState();
            state.formVisible = initialState.formVisible;
            state.formVariant = initialState.formVariant;
            state.deleteStatusModalVisible = initialState.deleteStatusModalVisible;
        },
        changeFormVariant: (state: DocumentTypesInterface, action: PayloadAction<"new" | "edit">) => {
            state.formVariant = action.payload;
        },
        changeDeleteModalVisibility: (state: DocumentTypesInterface, action: PayloadAction<boolean>) => {
            state.deleteStatusModalVisible = action.payload;
        },
        changeEditId: (state: DocumentTypesInterface, action: PayloadAction<number>) => {
            state.editId = action.payload;
        },
        changeEditTitle: (state: DocumentTypesInterface, action: PayloadAction<string>) => {
            state.editTitle = action.payload;
        },
        changeEditAlias: (state: DocumentTypesInterface, action: PayloadAction<string>) => {
            state.editAlias = action.payload;
        },
        changeEditDescription: (state: DocumentTypesInterface, action: PayloadAction<string>) => {
            state.editDescription = action.payload;
        },
        changeEditIsActive: (state: DocumentTypesInterface, action: PayloadAction<boolean | null>) => {
            state.editIsActive = action.payload;
        },
        changeDeleteId: (state: DocumentTypesInterface, action: PayloadAction<string>) => {
            state.deleteId = action.payload;
        },
    },
});

export const {
    changeFormVariant,
    changeFormVisibility,
    changeDeleteModalVisibility,
    changeEditId,
    changeEditTitle,
    changeEditAlias,
    changeEditDescription,
    changeEditIsActive,
    reset,
    changeDeleteId
} = DocumentTypesSlice.actions;

export const getSelectorForFormVisibility = (state: RootState) => state.documentTypes.formVisible
export const getSelectorForFormVariant = (state: RootState) => state.documentTypes.formVariant;
export const getSelectorForEditId = (state: RootState) => state.documentTypes.editId;
export const getSelectorForEditTitle = (state: RootState) => state.documentTypes.editTitle;
export const getSelectorForEditAlias = (state: RootState) => state.documentTypes.editAlias;
export const getSelectorForEditDescription = (state: RootState) => state.documentTypes.editDescription;
export const getSelectorForEditIsActive = (state: RootState) => state.documentTypes.editIsActive;
export const getSelectorForDeleteModalVisibility = (state: RootState) => state.documentTypes.deleteStatusModalVisible;
export const getSelectorForDeleteId = (state: RootState) => state.documentTypes.deleteId;

export const DocumentTypesReducer = DocumentTypesSlice.reducer;
